import {
  Container,
  Typography,
  Button,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import { Delete, Image } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Loader from "../utils/Loader";
import { useHistory, useParams } from "react-router-dom";
import firebase, { db, storage } from "../../config/Firebase";
import { useAuth } from "../../context/AuthContext";
import { useData } from "../../context/DataContext";
import { useHandling } from "../../context/HandleContext";
import { Column, Row } from "../utils/MaterialUIComponents";
const lvl1 = "level_1";
const lvl2 = "level_2";
const lvl3 = "level_3";
const useStyles = makeStyles((theme) => ({
  dropzone: {
    cursor: "pointer",
    border: (props) =>
      `3px dashed ${props.isDragActive ? theme.palette.primary.main : "#999"}`,
    padding: "2rem",
    outline: "none",
  },
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
  },
  thumb: {
    display: "inline-flex",
    borderRadius: 6,
    border: `1px solid #eaeaea`,
    marginBottom: 8,
    marginRight: 8,
    width: 120,
    height: 120,
    padding: 4,
    boxSizing: "border-box",
    position: `relative`,
  },
  thumbInner: {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
  },
  img: {
    display: "block",
    width: "auto",
    height: "100%",
  },
  delete: {
    top: 0,
    right: 0,
    position: `absolute`,
    "&:hover": {
      // backgroundColor: theme.palette.primary.light + " !important",
      color: theme.palette.primary.main + " !important",
      opacity: 1 + " !important",
    },
  },
}));

const Level = () => {
  const { id } = useParams();
  const { user, activeUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const { push } = useHistory();
  const { setSuccess, setError } = useHandling();
  const classes = useStyles();
  const data = useData();
  const { acceptedFiles, fileRejections, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: "image/*",
  });
  const [images, setImages] = useState([]);
  useEffect(() => {
    setImages(
      acceptedFiles.map((file, i) =>
        Object.assign(file, { src: URL.createObjectURL(file), i })
      )
    );
  }, [acceptedFiles]);
  useEffect(() => {
    if (fileRejections.length > 0) setError(fileRejections?.[0]?.errors[0]);
  }, [fileRejections, setError]);
  const showThumbs = () =>
    images.map(({ type, src, database, ...rest }, i) => (
      <>
        <div className={classes.thumb} key={i}>
          <div className={classes.thumbInner}>
            {type.split("/")[0] === "video" ? (
              <video muted src={src} className={classes.img}>
                No Preview Available
              </video>
            ) : (
              <img src={src} alt={src} className={classes.img} />
            )}
          </div>
          <IconButton
            onClick={() => {
              acceptedFiles.splice(rest.i, 1);
              setImages(
                acceptedFiles.map((file, i) =>
                  Object.assign(file, { src: URL.createObjectURL(file), i })
                )
              );
              setSuccess(
                new Error(`${type.split("/")[0]} deleted successfully`)
              );
            }}
            className={classes.delete}
          >
            <Delete color="inherit" />
          </IconButton>
        </div>
      </>
    ));
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const value = {
        [id]: {
          completed: true,
          approved: false,
        },
      };
      if (id === lvl1) {
        if (images[0]) {
          await storage.ref(`${id}/${user.uid}`).put(images[0]);
          const image = await storage.ref(`${id}/${user.uid}`).getDownloadURL();
          value[id].image = image;
        } else {
          throw new Error("Upload screenshot to complete Level 1");
        }
      }
      if (!activeUser[id]?.completed) {
        await db.collection("users").doc(user.uid).set(value, { merge: true });
      }
      setLoading(false);
      push(`/levels/level_${+id.split("_")[1] + 1}`);
    } catch (err) {
      setLoading(false);
      setError(err);
      console.error(err);
    }
  };
  const renderFileUpload = () => {
    if (id !== lvl1 && id !== lvl2) return;
    console.log(activeUser[id]?.approved);
    if (activeUser[id]?.approved)
      return <Typography variant="h4">Level Completed</Typography>;
    if (activeUser[id]?.completed)
      return (
        <Typography variant="h4">
          Level Completed Waiting for admin to Approve...
        </Typography>
      );
    if (id === lvl2) return;
    return (
      <Typography>
        <input {...getInputProps()} type="file" id="screenshot" required />
        <Button component="label" startIcon={<Image />} htmlFor="screenshot">
          Upload Screenshot
        </Button>
      </Typography>
    );
  };
  return (
    <div>
      <Container>
        {`level_${(activeUser.currentLevel || 0) + 1}` >= id ? (
          <>
            {loading && <Loader />}
            <Row className="centered">
              <Column lg={12}>
                <Typography variant="h3">Level {data[id]?.level}</Typography>
                <Typography variant="h6">Level {data[id]?.name}</Typography>
              </Column>
              <Column lg={6}>
                <div className="img_outer">
                  <video
                    className="img"
                    controls
                    src={data[id]?.video?.[0].src}
                  />
                </div>
              </Column>
              <Column lg={12}>{showThumbs()}</Column>
              <Column
                onSubmit={onSubmit}
                component="form"
                justify="flex-end"
                lg={12}
              >
                {renderFileUpload()}
                {id !== lvl3 && (
                  <Button type="submit" variant="contained" color="primary">
                    Next
                  </Button>
                )}
              </Column>
            </Row>
          </>
        ) : (
          <Typography variant="h2">Level Is not Unlocked yet !!!</Typography>
        )}
      </Container>
    </div>
  );
};

export default Level;
